import { useEffect } from "react";
import "./AdminIndex.css";
import { SidebarCol } from "../chatMain/Sidebar/Sidebar.jsx";
import { MainHeader } from "../chatMain/MainHeader/MainHeader.jsx";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartArea, faUser } from "@fortawesome/free-solid-svg-icons";
import { isAdminUser } from "../../utils/userUtils";

export const AdminIndex = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const isAdmin = isAdminUser(user);

  useEffect(() => {
    if (!isAdmin) {
      alert("You are not authorized to access this page");
      navigate("/home");
    }
  }, [isAdmin, navigate]);

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="admin-index-page" id="adminIndexPage">
      <div className="sidebar">
        <SidebarCol />
      </div>

      <div className="admin-index-container-wrapper">
        <div className="header">
          <MainHeader
            titleText={`Administrator Portal`}
            subtitleText={"Expand Your Insight"}
          />
        </div>

        <div className="admin-index-content-container">
          <div className="admin-index-main-content-wrapper">
            <div className="admin-index-section">
              <div className="admin-index-section-subsection-container">
                <div className="admin-index-sub-text">Home</div>
                <div className="admin-index-separator">/</div>
                <div className="admin-index-main-text">Admin</div>
              </div>
            </div>

            {/* Desktop / tablet cards (hidden on mobile via CSS) */}
            <div className="admin-index-content-section">
              <div
                className="admin-index-menu-item-container"
                onClick={() => navigate("/admin/usermanagement")}
              >
                <div className="admin-index-menu-item">
                  <div className="admin-index-menu-content-container">
                    <div className="admin-index-menu-icon">
                      <FontAwesomeIcon icon={faUser} />
                    </div>
                    <div className="admin-index-menu-text">User Management</div>
                    <div className="admin-index-menu-link">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6701)">
                          <path
                            d="M17.7075 11.2933L7.7075 1.29329C7.56765 1.15328 7.38939 1.05791 7.19531 1.01926C7.00122 0.980608 6.80003 1.00041 6.61721 1.07616C6.43439 1.15192 6.27815 1.28021 6.16828 1.44481C6.05841 1.6094 5.99984 1.80289 6 2.00079V22.0008C5.99984 22.1987 6.05841 22.3922 6.16828 22.5568C6.27815 22.7214 6.43439 22.8497 6.61721 22.9254C6.80003 23.0012 7.00122 23.021 7.19531 22.9823C7.38939 22.9437 7.56765 22.8483 7.7075 22.7083L17.7075 12.7083C17.8005 12.6154 17.8742 12.5051 17.9246 12.3837C17.9749 12.2623 18.0008 12.1322 18.0008 12.0008C18.0008 11.8694 17.9749 11.7392 17.9246 11.6178C17.8742 11.4964 17.8005 11.3862 17.7075 11.2933Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6701">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(-4 -4)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="admin-index-menu-item-container"
                onClick={() => navigate("/admin/analytics")}
              >
                <div className="admin-index-menu-item">
                  <div className="admin-index-menu-content-container">
                    <div className="admin-index-menu-icon">
                      <FontAwesomeIcon icon={faChartArea} />
                    </div>
                    <div className="admin-index-menu-text">Analytics</div>
                    <div className="admin-index-menu-link">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1868_6701)">
                          <path
                            d="M17.7075 11.2933L7.7075 1.29329C7.56765 1.15328 7.38939 1.05791 7.19531 1.01926C7.00122 0.980608 6.80003 1.00041 6.61721 1.07616C6.43439 1.15192 6.27815 1.28021 6.16828 1.44481C6.05841 1.6094 5.99984 1.80289 6 2.00079V22.0008C5.99984 22.1987 6.05841 22.3922 6.16828 22.5568C6.27815 22.7214 6.43439 22.8497 6.61721 22.9254C6.80003 23.0012 7.00122 23.021 7.19531 22.9823C7.38939 22.9437 7.56765 22.8483 7.7075 22.7083L17.7075 12.7083C17.8005 12.6154 17.8742 12.5051 17.9246 12.3837C17.9749 12.2623 18.0008 12.1322 18.0008 12.0008C18.0008 11.8694 17.9749 11.7392 17.9246 11.6178C17.8742 11.4964 17.8005 11.3862 17.7075 11.2933Z"
                            fill="black"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1868_6701">
                            <rect
                              width="32"
                              height="32"
                              fill="white"
                              transform="translate(-4 -4)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile-only message (hidden on desktop via CSS) */}
            <div className="admin-index-mobile-message">
              <h2>User management and Analytics are not on mobile</h2>
              <p>
                We're sorry, but the User management and Analytics pages are
                currently not supported on mobile devices. For the best
                experience and full functionality, please access this page from
                a desktop or laptop computer. We're working on making this
                feature mobile-friendly and appreciate your patience!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
